require('es6-promise').polyfill();
require('isomorphic-fetch');

import React, {Component} from 'react';
import ReactDOM from 'react-dom';
import JSHeader from '../components/JSHeader';
import registerServiceWorker from '../registerServiceWorker';
import queryString from 'query-string';
import SubmitRouter from './SubmitTimeslotsRouter';
import CircularProgress from '@mui/material/CircularProgress';

class App extends Component {
    constructor(props) {
        // Required step: always call the parent class' constructor
        super(props);

        // Set the state directly. Use props if necessary.
        this.state = {
            timezones: window.timezones,
            resData:{
                company:{
                    name:''
                },
                job:{
                    title:''
                },
                interviewType:{},
                availabilityRequest:{}
            }
        };
    }

    componentDidMount() {
        const {timezones} = this.state;
        let tz = Intl.DateTimeFormat().resolvedOptions().timeZone;
        let currentTimezone = {'id': -1};

        for(let i=0; i<timezones.length; i++){
            if(timezones[i].openSysId === tz){
                currentTimezone = timezones[i];
                this.state.selectedTimezone = timezones[i];
                break;
            }
        }

        this.getAvailabilities(currentTimezone.id, function(result, thisObj){
            thisObj.setState({isLoading: false});
            thisObj.setState({resData: result});
            if(result.msgInfo && result.msgInfo !== 200){
                window.location.hash = "#/fail";
            }
        });
    }

    getAvailabilities = (timezoneId, callback) => {
        const values = queryString.parse(window.location.search);
        const companyId = values.c;
        const applicationId = values.appid;
        const requestId = values.requestid;

        const url = window.jvUrls.jobSeeker+'/action/app/interview/availabilityRequest/'+companyId+'/'+applicationId+'/request/'+requestId+'?timezoneId='+timezoneId;
        fetch(url)
        .then(result => result.json())
        .then(result => {
            callback(result, this);
        })
    }

    useStyles = () => {
        return useStyles;
    }

    render() {
        const {resData} = this.state;

        if(resData.msgInfo){
            return (
                <div>
                    <div className='header'>
                        <JSHeader companyName={resData.subsidiary ? resData.subsidiary.name : resData.company.name} />
                        <div className='blue-tri-bg'>
                            <div className='general-width margin-width-auto white padding-top-x-small padding-bottom-x-small subHeader'>
                                <div className='inline-block padding-right-small margin-right-small border-border-right'> {window['i18n']['JOB_TITLE']}: <span className='font-light'>{resData.job.title}</span> </div>
                                <div className='inline-block'> {window['i18n']['INTERVIEW_DURATION']}: <span className='font-light'>{resData.availabilityRequest.totalDuration} {window['i18n']['MINS']} </span></div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="views">
                            <SubmitRouter resData={this.state.resData}/>
                        </div>
                    </div>
                </div>
            );
        }else{
            return (
                <div className="loader">
                    <CircularProgress  className="loaderIcon" />
                </div>
            );
        }
    }
}
ReactDOM.render(<App />, document.getElementById('root'));
registerServiceWorker();